export const UserRoles = {
  VISITOR: "visitor",
  MARRIED_COUPLE: "married-couple",
  YOUNG_GIRLS: "young-girls",
  YOUNG_BOYS: "young-boys",
  MARRIED_HUSBAND: "married-husband",
  MARRIED_WIFE: "married-wife",
  WOMEN: "women",
};

export const UserRoleOptions = [
  { value: UserRoles.VISITOR, label: "Visitor" },
  { value: UserRoles.MARRIED_COUPLE, label: "Married Couple" },
  { value: UserRoles.YOUNG_GIRLS, label: "Young Girls" },
  { value: UserRoles.YOUNG_BOYS, label: "Young Boys" },
  { value: UserRoles.MARRIED_HUSBAND, label: "Married Husband" },
  { value: UserRoles.MARRIED_WIFE, label: "Married Wife" },
  { value: UserRoles.WOMEN, label: "Women" },
];
